<template>
  <section>
    <el-col style="float:right; width: 38%; display:inline;   font-size:14px; margin-top: 10px;" >
      <div style=" float: right;padding-right: 8px;">
        <span :style="getStylecolor(0,4)">
        </span>
        任务取消
      </div>
      <div style=" float: right;padding-right: 8px;">
        <span :style="getStylecolor(0,3)">
        </span>
        任务异常
      </div>
      <div style=" float: right;padding-right: 8px;">
          <span :style="getStylecolor(0,11)">
          </span>
          任务异常已处理
        </div>
      <div style=" float: right;padding-right: 8px;">
        <span :style="getStylecolor(0,1)">
        </span>
        未开始
      </div>
      <div style=" float: right;padding-right: 8px;">
        <span :style="getStylecolor(0,2)">
        </span>
        进行中
      </div>
      <div style=" float: right;padding-right: 8px;">
        <span :style="getStylecolor(0,5)">
        </span>
        已完成
      </div>
    </el-col>

    <!--工具条-->
    <RunCenterTaskToolbar :buttonList="buttonList" @callFunction="callFunction" ></RunCenterTaskToolbar>

    <!--列表-->
    <el-table
      :data="runCenterTaskList"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%; font-size:18px;"
    >
      <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
      <el-table-column
        fixed="left"
        label="操作"
        width="165">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
            <div v-if="scope.row.IsCancel" style="display: inline-flex;">
              <div v-if="item.name !== '恢复任务' && item.name !=='任务详情操作日记' && item.name !=='处理' && item.name==='取消任务'">
                <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide && scope.row.IsStateOne" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
              </div>
              <div v-else-if="item.name !== '恢复任务' && item.name !=='任务详情操作日记' && item.name !=='处理'">
                <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
              </div>
            </div>  
            <div v-else>
              <div v-if="(item.name === '恢复任务' && item.Func === 'handleRecoverTask')|| item.name==='操作日记'">
                <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
              </div>
            </div>           
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="LineName" label="线路名称" width="110"></el-table-column>
      <el-table-column prop="ShiftName" label="班次" width="90" sortable></el-table-column>
      <el-table-column prop="SelfMadeNumber" label="车辆自编号" width="135" sortable></el-table-column>
      <el-table-column prop="LicensePlateNumber" label="车牌号" width="120" sortable></el-table-column>
      <el-table-column prop="DriverName" label="司机" width="100" sortable></el-table-column>
      <el-table-column
        label="上行计划发车时间"
        width="400">
        <template slot-scope="scope">
          <span v-for="item in scope.row.RunCenterTaskUpList" :key="item.id">
            <el-button style="font-size:18px;" type="text" v-if="!item.IsCharter && item.DisposeResults!=null && item.State!=4" :style="getStyle(1,11)" @click="handleShowDetails(item,scope.row.LineName,scope.row.LicensePlateNumber,scope.row.DriverName)">{{item.DepartureTimeStr}}</el-button>
            <el-button style="font-size:18px;" type="text" v-else-if="!item.IsCharter" :style="getStyle(1,item.State)" @click="handleShowDetails(item,scope.row.LineName,scope.row.LicensePlateNumber,scope.row.DriverName)">{{item.DepartureTimeStr}}</el-button>
            <el-button style="font-size:18px;" type="text" v-else :style="getStyle(1,0)" @click="handleShowDetails(item,scope.row.LineName,scope.row.LicensePlateNumber,scope.row.DriverName)">
              
              <div v-if="scope.row.ShiftName === '包车'" style="color:red;">包车</div> 
              <div v-else  >{{item.DepartureTimeStr}}</div>

              <div v-if="scope.row.ShiftName === '包车'">{{item.StartTimeStr}}</div> 
              <div v-if="scope.row.ShiftName === '包车'">{{item.EndTimeStr}}</div> 
              <div v-else style="color:red;">包车</div>
              </el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="下行计划发车时间"
        width="400">
        <template slot-scope="scope">
          <span v-for="item in scope.row.RunCenterTaskDownList" :key="item.id">
            <el-button style="font-size:18px;" type="text" v-if="!item.IsCharter&& item.DisposeResults!=null && item.State!=4" :style="getStyle(1,11)" @click="handleShowDetails(item,scope.row.LineName,scope.row.LicensePlateNumber,scope.row.DriverName)">{{item.DepartureTimeStr}}</el-button>
            <el-button style="font-size:18px;" type="text" v-else-if="!item.IsCharter" :style="getStyle(1,item.State)" @click="handleShowDetails(item,scope.row.LineName,scope.row.LicensePlateNumber,scope.row.DriverName)">{{item.DepartureTimeStr}}</el-button>
            <el-button style="font-size:18px;" type="text" v-else :style="getStyle(1,0)" @click="handleShowDetails(item,scope.row.LineName,scope.row.LicensePlateNumber,scope.row.DriverName)">
              <div v-if="scope.row.ShiftName === '包车'" style="color:red;">包车</div> 
              <div v-else  >{{item.DepartureTimeStr}}</div>

              <div v-if="scope.row.ShiftName === '包车'">{{item.StartTimeStr}}</div> 
              <div v-if="scope.row.ShiftName === '包车'">{{item.EndTimeStr}}</div> 
              <div v-else style="color:red;">包车</div>
            </el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="Toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[20, 50, 100, 200]"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--任务详情-->
    <el-dialog
      title="任务详情"
      :visible.sync="taskDetailsFormVisible"
      v-model="taskDetailsFormVisible"
      :close-on-click-modal="false"
      width="70%"
    >
      <el-table
        :data="runCenterTaskDetails"
        highlight-current-row
        style="width: 100%;"
      >
        <el-table-column fixed="left" type="index" label="序号" width="50"></el-table-column>
        <el-table-column
          fixed="left"
          label="操作"
          width="200">
          <template slot-scope="scope">
            <span v-for="item in operationButtonList" :key="item.id">
              <span v-if="scope.row.State === 4"> 
               
                <span v-if="item.name === '恢复任务'">
                  <el-button type="text" style="padding-right:6px;" size="small" v-if="item.name === '恢复任务' && item.Func === 'handleRecoverSingleTask'" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
                </span>                
              </span> 
              <span v-else>
                <el-button type="text" style="padding-right:6px;" size="small" v-if="item.IsHide && (item.name === '取消任务' || item.name === '换车' || item.name === '换时间' || item.name === '换司机'|| (item.name === '包车' && !scope.row.IsCharter) || (item.name === '取消包车' && scope.row.IsCharter))" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
              </span>    
              <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide && ((item.name === '处理'&& (scope.row.State===3||(scope.row.State>5&&scope.row.State<11)))||item.name === '任务详情操作日记')" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column fixed="left" prop="LineName" label="线路名称" width="80"></el-table-column>
        <el-table-column fixed="left" prop="ShiftName" label="班次" width="80"></el-table-column>
        <el-table-column prop="Times" label="趟次" width="50"></el-table-column>
        <el-table-column prop="LicensePlateNumber" label="车牌号" width="100"></el-table-column>
        <el-table-column prop="DriverName" label="司机" width="80"></el-table-column>       
      <!--  <el-table-column prop="StartTimeStr" label="发车时间" width="108"></el-table-column>
        <el-table-column prop="EndTimeStr" label="结束时间" width="108"></el-table-column>
        <el-table-column prop="StartAddr" label="发车地点" width="108"></el-table-column>
        <el-table-column prop="EndAddr" label="地点" width="108"></el-table-column>-->

        <el-table-column
        label="计划发车时间"
        width="108" >
        <template slot-scope="scope">  
            <div v-if="scope.row.IsCharter === true"
               style="color:red;">{{scope.row.StartTimeStr + "--" + scope.row.EndTimeStr}}</div> 
            <div v-if="scope.row.IsCharter === false" >{{scope.row.DepartureTimeStr}}</div> 
        </template>
      </el-table-column> 

      <el-table-column
        label="发车地点"
        width="150" >
        <template slot-scope="scope">  
            <div v-if="scope.row.IsCharter === true"
               style="color:red;">{{scope.row.StartAddr + "--" + scope.row.EndAddr}}</div>               
        </template>
      </el-table-column> 

 <!--       <el-table-column prop="DepartureTimeStr" label="计划发车时间" width="108"></el-table-column>  -->
        <el-table-column prop="ActualDepartureTimeStr" label="实际发车时间" width="108"></el-table-column>
        <el-table-column prop="TimeDifference" label="发车时差(分)" width="108"></el-table-column>
        <el-table-column prop="ActualEndTimeStr" label="实际到达时间" width="108"></el-table-column>
        <el-table-column prop="StateName" label="状态" width="150"></el-table-column>
        <el-table-column prop="DisposeResultsName" label="处理结果" width="300"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="taskDetailsFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!--添加任务-->
    <el-dialog
      title="添加任务"
      :visible.sync="handleAddSchedulingTaskFormVisible"
      v-model="handleAddSchedulingTaskFormVisible"
      :close-on-click-modal="false"
      width="25%"
    >
      <el-form :model="addschedulingTaskForm" label-width="80px" :rules="addschedulingTaskFormRules" ref="addschedulingTaskForm">
        <el-row>
          <el-form-item label="线路名称" prop="LineName" label-width="110px">
            <el-input v-model="addschedulingTaskForm.LineName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="班次" prop="ShiftName" label-width="110px">
            <el-input v-model="addschedulingTaskForm.ShiftName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="线路模式" prop="CancelTask" label-width="110px" >
            <el-select style="width: 100%;" v-model="addschedulingTaskForm.LineMode" filterable placeholder="请选择车牌号" :disabled="addschedulingTaskForm.Isdisabled">
              <el-option value="上行">上行</el-option>
              <el-option value="下行">下行</el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发车时间" prop="DepartureTimeStr" label-width="110px">
            <el-time-picker v-model="addschedulingTaskForm.DepartureTimeStr" value-format="HH:mm" format="HH:mm"></el-time-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="车牌号" prop="VehicleId" label-width="110px">
            <el-select style="width: 100%;" v-model="addschedulingTaskForm.VehicleId" filterable placeholder="请选择车牌号">
              <el-option
                v-for="item in vehicleList"
                :key="item.Id"
                :value="item.Id"
                :label="item.LicensePlateNumber"
              >
                <span style="float: left">{{ item.LicensePlateNumber }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="司机" prop="DriverId" label-width="110px">
            <el-select style="width: 100%;" v-model="addschedulingTaskForm.DriverId" filterable placeholder="请选择司机">
              <el-option
                v-for="item in driverList"
                :key="item.Id"
                :value="item.Id"
                :label="item.Name"
              >
                <span style="float: left">{{ item.Name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleAddSchedulingTaskFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSchedulingTaskSubmit" :loading="addSchedulingTaskLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--调班-->
    <el-dialog
      title="调班"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      width="25%"
    >
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-row>
          <el-form-item label="线路名称" prop="LineName" label-width="110px">
            <el-input v-model="editForm.LineName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="班次" prop="ShiftName" label-width="110px">
            <el-input v-model="editForm.ShiftName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="车牌号" prop="VehicleId" label-width="110px">
            <el-select style="width: 100%;" v-model="editForm.VehicleId" filterable placeholder="请选择车牌号">
              <el-option
                v-for="item in vehicleList"
                :key="item.Id"
                :value="item.Id"
                :label="item.LicensePlateNumber"
              >
                <span style="float: left">{{ item.LicensePlateNumber }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="司机" prop="DriverId" label-width="110px">
            <el-select style="width: 100%;" v-model="editForm.DriverId" filterable placeholder="请选择司机">
              <el-option
                v-for="item in driverList"
                :key="item.Id"
                :value="item.Id"
                :label="item.Name"
              >
                <span style="float: left">{{ item.Name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>
    <!--换车-->
    <el-dialog
      title="换车"
      :visible.sync="changeVehicleFormVisible"
      v-model="changeVehicleFormVisible"
      :close-on-click-modal="false"
      width="25%"
    >
      <el-form :model="changeVehicleForm" label-width="80px" :rules="changeVehicleFormRules" ref="changeVehicleForm">
        <el-row>
          <el-form-item label="线路名称" prop="LineName" label-width="110px">
            <el-input v-model="changeVehicleForm.LineName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="班次" prop="ShiftName" label-width="110px">
            <el-input v-model="changeVehicleForm.ShiftName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="司机" prop="DriverName" label-width="110px">
            <el-input v-model="changeVehicleForm.DriverName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="车牌号" prop="VehicleId" label-width="110px">
            <el-select style="width: 100%;" v-model="changeVehicleForm.VehicleId" filterable placeholder="请选择车牌号">
              <el-option
                v-for="item in vehicleList"
                :key="item.Id"
                :value="item.Id"
                :label="item.LicensePlateNumber"
              >
                <span style="float: left">{{ item.LicensePlateNumber }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="changeVehicleFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="changeVehicleSubmit" :loading="changeVehicleLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--换司机-->
    <el-dialog
      title="换司机"
      :visible.sync="changeDriverFormVisible"
      v-model="changeDriverFormVisible"
      :close-on-click-modal="false"
      width="25%"
    >
      <el-form :model="changeDriverForm" label-width="80px" :rules="changeDriverFormRules" ref="changeDriverForm">
        <el-row>
          <el-form-item label="线路名称" prop="LineName" label-width="110px">
            <el-input v-model="changeDriverForm.LineName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="班次" prop="ShiftName" label-width="110px">
            <el-input v-model="changeDriverForm.ShiftName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="车牌号" prop="LicensePlateNumber" label-width="110px">
            <el-input v-model="changeDriverForm.LicensePlateNumber" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="司机" prop="DriverId" label-width="110px">
            <el-select style="width: 100%;" v-model="changeDriverForm.DriverId" filterable placeholder="请选择司机">
              <el-option
                v-for="item in driverList"
                :key="item.Id"
                :value="item.Id"
                :label="item.Name"
              >
                <span style="float: left">{{ item.Name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="changeDriverFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="changeDriverSubmit" :loading="changeDriverLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--换时间-->
    <el-dialog
      title="换时间"
      :visible.sync="changeDepartureTimeStrFormVisible"
      v-model="changeDepartureTimeStrFormVisible"
      :close-on-click-modal="false"
      width="25%"
    >
      <el-form :model="changeDepartureTimeStrForm" label-width="80px" :rules="changeDepartureTimeStrFormRules" ref="changeDepartureTimeStrForm">
        <el-row>
          <el-form-item label="线路名称" prop="LineName" label-width="110px">
            <el-input v-model="changeDepartureTimeStrForm.LineName" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="班次" prop="ShiftName" label-width="110px">
            <el-input v-model="changeDepartureTimeStrForm.ShiftName" :disabled="true" />
          </el-form-item>
        </el-row>
        
        <el-row>
          <el-form-item label="发车时间" prop="DepartureTimeStr" label-width="110px">
            <el-time-picker v-model="changeDepartureTimeStrForm.DepartureTimeStr" value-format="HH:mm" format="HH:mm"></el-time-picker>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="changeDepartureTimeStrFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="changeDepartureTimeStrSubmit" :loading="changeDepartureTimeStrLoading">提交</el-button>
      </div>
    </el-dialog>

      <!--包车-->
      <el-dialog
      title="包车"
      :visible.sync="changeCharterFormVisible"
      v-model="changeCharterFormVisible"
      :close-on-click-modal="false"
      width="25%"
    >
      <el-form :model="changeCharterForm" label-width="80px"  ref="changeCharterForm">   
        <el-row>
          <el-form-item label="发车时间" prop="StartTimeStr" label-width="110px">
            <el-time-picker v-model="changeCharterForm.StartTimeStr" value-format="HH:mm" format="HH:mm"></el-time-picker>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="结束时间" prop="EndTimeStr" label-width="110px">
            <el-time-picker v-model="changeCharterForm.EndTimeStr" value-format="HH:mm" format="HH:mm"></el-time-picker>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="发车地点" prop="StartAddr" label-width="110px">
            <el-input v-model="changeCharterForm.StartAddr" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="结束地点" prop="EndAddr" label-width="110px">
            <el-input v-model="changeCharterForm.EndAddr" />
          </el-form-item>
        </el-row>
       
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="changeCharterFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="changeCharterSubmit" :loading="changeCharterLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="80px" ref="addForm">
        <el-row>
          <el-form-item label="司机" prop="DriverName" label-width="110px">
            <el-select style="width: 100%;" v-model="addForm.DriverId" @change="AddDrivechange" filterable placeholder="请选择司机">
              <el-option
                v-for="item in driverList"
                :key="item.Id"
                :value="item.Id"
                :label="item.Name"
              >
                <span style="float: left">{{ item.Name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="车牌号" prop="VehicleId" label-width="110px">
            <el-select style="width: 100%;" v-model="addForm.VehicleId" filterable placeholder="请选择车牌号">
              <el-option
                v-for="item in vehicleList"
                :key="item.Id"
                :value="item.Id"
                :label="item.LicensePlateNumber"
              >
                <span style="float: left">{{ item.LicensePlateNumber }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发车日期" prop="DepartureDate" label-width="110px">
            <el-input v-model="addForm.DepartureDate" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发车模板" prop="SchedulingTemplateId" label-width="110px">
            <el-select style="width: 100%;" v-model="addForm.SchedulingTemplateId" @change="handleIsopenSelect" placeholder="请选择发车模板">
              <el-option
                v-for="item in schedulingtemplateList"
                :key="item.Id"
                :value="item.Id"
                :label="item.DepartureTemplate"
                @click.native=getShiftNameList(addForm.SchedulingTemplateId)
              >
                <span style="float: left">{{ item.DepartureTemplate }}</span>
              </el-option>              
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发车线路" prop="BusLinesId" label-width="110px">
            <el-select style="width: 100%;" v-model="addForm.BusLinesId" placeholder="请选择发车线路">
              <el-option
                v-for="item in busLiness"
                :key="item.Id"
                :value="item.Id"
                :label="item.LineChineseName"
              >
                <span style="float: left">{{ item.LineChineseName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="班次名称" prop="ShiftName" label-width="110px">
            <el-select style="width: 100%;" v-model="addForm.ShiftName" filterable placeholder="请选择班次名称">
              <el-option
                v-for="item in shiftNameList"
                :key="item"
                :value="item"
                :label="item"
              >
                <span style="float: left">{{ item }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

     <!--新增包车界面-->
     <el-dialog
      title="新增包车"
      :visible.sync="addCharterFormVisible"
      v-model="addCharterFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addCharterForm" label-width="80px" ref="addCharterForm">
        <el-row>
          <el-form-item label="司机" prop="DriverName" label-width="110px">
            <el-select style="width: 100%;" v-model="addCharterForm.DriverId" @change="AddCharterDrivechange" filterable placeholder="请选择司机">
              <el-option
                v-for="item in driverList"
                :key="item.Id"
                :value="item.Id"
                :label="item.Name"
              >
                <span style="float: left">{{ item.Name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="车牌号" prop="VehicleId" label-width="110px">
            <el-select style="width: 100%;" v-model="addCharterForm.VehicleId" filterable placeholder="请选择车牌号">
              <el-option
                v-for="item in vehicleList"
                :key="item.Id"
                :value="item.Id"
                :label="item.LicensePlateNumber"
              >
                <span style="float: left">{{ item.LicensePlateNumber }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
       
        <el-row>
          <el-form-item label="开始时间" prop="StartTimeStr" label-width="110px">
            <el-time-picker v-model="addCharterForm.StartTimeStr" value-format="HH:mm" format="HH:mm"></el-time-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="结束时间" prop="EndTimeStr" label-width="110px">
            <el-time-picker v-model="addCharterForm.EndTimeStr" value-format="HH:mm" format="HH:mm"></el-time-picker>
          </el-form-item>
        </el-row>  
        <el-row>
            <el-form-item label="起始地点" prop="StartAddr" label-width="110px">
              <el-input v-model="addCharterForm.StartAddr" />
            </el-form-item>         
        </el-row> 
        <el-row>
            <el-form-item label="结束地点" prop="EndAddr" label-width="110px">
              <el-input v-model="addCharterForm.EndAddr" />
            </el-form-item>         
        </el-row>        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addCharterFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addCharterTaskSubmit" :loading="addCharterLoading">提交</el-button>
      </div>
    </el-dialog>

   <!--异常处理界面-->
    <el-dialog 
      title="异常处理" 
      :visible.sync="AbnormalFormVisible" 
      v-model="AbnormalFormVisible" 
      :close-on-click-modal="false"
      width="25%"
    >
      <el-form :model="AbnormalForm" label-width="80px" :rules="AbnormalFormRules" ref="AbnormalForm">
        <el-form-item label="处理结果" prop="DisposeResults" label-width="110px">
          <el-select style="width: 100%;" v-model="AbnormalForm.DisposeResults" filterable placeholder="请选择处理结果">
            <el-option v-for="item in disposeResultsModeList" :key="item.Id" :value="item.DictCode" :label="item.DictName">
              <span style="float: left">{{ item.DictName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="异常原因"  label-width="110px" >
            <el-input type="textarea" :autosize="{ minRows: 8, maxRows: 100}" v-model="AbnormalForm.AbnormalCause"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="AbnormalFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="AbnormalSubmit" :loading="AbnormalLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--操作日记-->
    <el-dialog
      title="操作日记"
      :visible.sync="TwoTableOperateDataLogFormVisible"
      v-model="TwoTableOperateDataLogFormVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="60%"
    >
      <TwoTableOperateDataLog v-if="TwoTableOperateDataLogFormVisible" :oneEntityName="oneEntityName" :oneEntityKey="oneEntityKey" :twoEntityName="twoEntityName" :twoEntityKey="twoEntityKey"></TwoTableOperateDataLog>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="TwoTableOperateDataLogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>

  </section>
</template> 

<script>
import util from "../../../util/date";
import { getRunCenterTaskListPage, getBusLinesListPage, getDriverListPage, getVehiclesListPage, addRunCenterTask, editRunCenterTask, runCenterCancelTaskByShiftName, runCenterCancelSingleTask, runCenterChangeVehicleSingleTask, runCenterChangeDriverSingleTask, runCenterCharterTask, runCenterCancelCharterTask, exportRunCenterTask,runCenterChangeDepartureTimeStrSingleTask,runCenterChangeCharterSingleTask,getClassSubitem,getSchedulingTemplateListPage,getLineManVehicleListPage,runCenterRecoverTaskByShiftName,runCenterRecoverSingleTask,getByDriverIdVehiclesData,postRunCenterTask,runCenteraddCharterTask,getDictionaryListPageByDictNameAndDictCode,RunCenterTaskAbnormalDisposeUser,getShiftNameListPage} from "../../api/api";
import { getButtonList,getOperationButtonList } from "../../promissionRouter";
import RunCenterTaskToolbar from "../../components/QueryToolbar/RunCenterTaskToolbar";
import TwoTableOperateDataLog from "../../components/TwoTableOperateDataLog";
import { currentDate } from '../../baseCommon.js';

export default {
  components: { RunCenterTaskToolbar,TwoTableOperateDataLog },
  data() {
    return {
      filters: {
        busLinesId: "",
        shiftName: "",
        driverId: "",
        vehicleId: "",
        taskState: ""
      },
      oneEntityName: '', //操作日记中的第一张表名称
      oneEntityKey: '', //操作日记中的第一张表的Id
      twoEntityName:'',//操作日记中的第二张表名称
      twoEntityKey:'',//操作日记中的第二张表的Id
      buttonList: [],
      operationButtonList: [],
      runCenterTaskList: [], //运行中心任务列表
      driverList: [], //驾驶员列表
      vehicleList: [], //车辆列表
      disposeResultsModeList: [], //处理结果列表
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      taskDetailsFormVisible: false,
      TwoTableOperateDataLogFormVisible: false, //查看操作日记界面是否显示
      editFormVisible: false, //调班界面是否显示
      editLoading: false,
      editFormRules: {
        VehicleId: [{ required: true, message: "请选择车牌号", trigger: "blur" }],
        DriverId: [{ required: true, message: "请选择司机", trigger: "blur" }]
      },
      //调班界面数据
      editForm: {
        Id: 0,
        BusLinesId: 0,
        LineName: "",
        ShiftName: "",
        VehicleId: 0,
        DriverId: 0,
        BeforeUpdateVehicleId: 0,
        BeforeUpdateDriverId: 0
      },
      changeVehicleFormVisible: false, //换车界面是否显示
      changeVehicleLoading: false,
      changeVehicleFormRules: {
        VehicleId: [{ required: true, message: "请选择车牌号", trigger: "blur" }]
      },
      //换车界面数据
      changeVehicleForm: {
        Id: 0,
        BusLinesId: 0,
        LineName: "",
        ShiftName: "",
        DriverName: "",
        VehicleId: 0
      },
      changeDriverFormVisible: false, //换司机界面是否显示
      changeDriverLoading: false,
      changeDriverFormRules: {
       DriverId: [{ required: true, message: "请选择司机", trigger: "blur" }]
      },         
      //换司机界面数据
      changeDriverForm: {
        Id: 0,
        BusLinesId: 0,
        LineName: "",
        ShiftName: "",
        LicensePlateNumber: "",
        DriverId: 0
      },
      
      runCenterTaskDetails: [],//运行中心任务详细数据
      //换时间界面数据
      changeDepartureTimeStrFormVisible: false, 
      changeDepartureTimeStrLoading: false,   
      changeDepartureTimeStrForm: {
        Id: 0,
        BusLinesId: 0,
        LineName: "",
        ShiftName: "",
        LicensePlateNumber: "",
        DriverId: 0,
        DepartureTimeStr:""
      },
      changeDepartureTimeStrFormRules: {
        DepartureTimeStr: [{ required: true, message: "请选择发车时间", trigger: "blur" }]
      },       
     
      //包车界面数据
      changeCharterFormVisible: false, 
      changeCharterLoading: false,  
      changeCharterForm: {
        Id: 0,       
        StartTimeStr: "07:00",
        EndTimeStr: "18:00",
        StartAddr: "",
        EndAddr: ""
      },
      changeCharterFormRules: {
        StartTimeStr: [{ required: true, message: "请选择发车时间", trigger: "blur" }],
        EndTimeStr: [{ required: true, message: "请选择结束时间", trigger: "blur" }]
      },

      //添加包车界面数据
      addCharterFormVisible: false, //新增包车界面是否显示
      addCharterLoading:false,
      addCharterForm: {
        SchedulingId: 0,
        VehicleId: 0,
        DriverName: "",
        // DepartureDate: "",
        StartTimeStr: "",
        EndTimeStr: "",
        StartAddr: "",
        EndAddr: "",        
        IsScheduling: true,
        IsCancelShift: false
      },

      addFormVisible: false, //新增界面是否显示
      //添加界面数据
      addForm: {
        SchedulingId: 0,
        BusLinesName: "",
        VehicleId: 0,
        DriverName: "",
        DepartureDate: "",
        OldBusLinesId: 0,
        BusLinesId: 0,
        DriverId: 0,
        ShiftName: "",
        OldShiftName: "",
        IsScheduling: true,
        IsCancelShift: false
      },
      addLoading:false,
      shiftNameList: [], //班次名称列表
      schedulingtemplateList: [], //发车模板
      schedulingTemplateList:[],
      busLiness: [], //线路列表
      handleAddSchedulingTaskFormVisible: false, //添加排班任务界面是否显示
      addSchedulingTaskLoading: false,
      addschedulingTaskFormRules: {
        DepartureTimeStr: [{ required: true, message: "发车时间不能为空", trigger: "blur" }],
        VehicleId: [{ required: true, message: "请选择车牌号", trigger: "blur" }],
        DriverId: [{ required: true, message: "请选择司机", trigger: "blur" }]
      },
      //添加排班任务
      addschedulingTaskForm: {
        SchedulingId: 0,
        ShiftId: 0,
        DepartureTimeId: 0,
        SchedulingShiftRecordId: 0,
        BusLinesId: 0,
        LineName: "",
        ShiftName: "",
        VehicleId: 0,
        OldVehicleId: 0,
        DriverId: 0,
        OldDriverId: 0,
        DepartureDate: "",
        DepartureTimeStr: "",
        CancelTask: false,
        LineMode:"",
        Isdisabled:false
      },
      AbnormalFormVisible: false, //异常处理界面是否显示
      AbnormalLoading: false,
      AbnormalFormRules: {
        DisposeResults: [{ required: true, message: "请选择处理结果", trigger: "blur" }],
        AbnormalCause: [{ required: true, message: "请输入异常原因", trigger: "blur" }]
      },
      //异常处理界面数据
      AbnormalForm: {
        DisposeResults: "" ,
        AbnormalCause:"",
        Id: 0
      },
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        busLinesId: item.busLinesId,
        shiftName: item.shiftName,
        driverId: item.driverId,
        vehicleId: item.vehicleId,
        taskState: item.taskState
      };
      if (item.Func !== undefined)
        this[item.Func].apply(this, item);
      this.getRunCenterTask();
      
    },
    operationButtonFunction(item,row){
      this.currentRow = row;
      this[item.Func].apply(this,item);
    },
    handleIsopenSelect() {
	      this.$forceUpdate()
	   },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getRunCenterTask();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getRunCenterTask();
    },
    // 取消任务
    handleCancelTask(){
      this.$confirm("确认取消任务吗？", "提示", {}).then(() => {
        let rowData = Object.assign({}, this.currentRow);
        let para = {
          Id: rowData.Id,
          BusLinesId: rowData.BusLinesId,
          ShiftName: rowData.ShiftName,
          VehicleId: rowData.VehicleId,
          DriverId: rowData.DriverId
        };
        runCenterCancelTaskByShiftName(para).then(res => {
          if (util.isEmt.format(res)) {
            return;
          }

          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });

            this.queryRunCenterTask();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      }).catch(() => {
          
      });
    },
    // 恢复任务
    handleRecoverTask(){
      this.$confirm("确认恢复任务吗？", "提示", {}).then(() => {
        let rowData = Object.assign({}, this.currentRow);
        let para = {
          Id: rowData.Id,
          BusLinesId: rowData.BusLinesId,
          ShiftName: rowData.ShiftName,
          VehicleId: rowData.VehicleId,
          DriverId: rowData.DriverId
        };
        runCenterRecoverTaskByShiftName(para).then(res => {
          if (util.isEmt.format(res)) {
            return;
          }

          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });

            this.queryRunCenterTask();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      }).catch(() => {
          
      });
    },
    // 取消单条任务
    handleCancelSingleTask(){
      this.$confirm("确认取消该条任务吗？", "提示", {}).then(() => {
        let rowData = Object.assign({}, this.currentRow);
        let para = {
          Id: rowData.Id
        };
        runCenterCancelSingleTask(para).then(res => {
          if (util.isEmt.format(res)) {
            return;
          }

          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });

            this.taskDetailsFormVisible = false;
            this.queryRunCenterTask();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      }).catch(() => {
          
      });
    },
    // 恢复单条任务
    handleRecoverSingleTask(){
      this.$confirm("确认恢复该条任务吗？", "提示", {}).then(() => {
        let rowData = Object.assign({}, this.currentRow);
        let para = {
          Id: rowData.Id
        };
        runCenterRecoverSingleTask(para).then(res => {
          if (util.isEmt.format(res)) {
            return;
          }

          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });

            this.taskDetailsFormVisible = false;
            this.queryRunCenterTask();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      }).catch(() => {
          
      });
    },
    // 单条任务换车
    handleChangeVehicleSingleTask(){
      let row = this.currentRow;
      this.changeVehicleFormVisible = true;
      this.changeVehicleForm = Object.assign({}, row);
    },
    // 单条任务换司机
    handleChangeDriverSingleTask(){
      let row = this.currentRow;
      this.changeDriverFormVisible = true;
      this.changeDriverForm = Object.assign({}, row);
    },
    // 单条任务换时间
    handleChangeDepartureTimeStrSingleTask (){
      let row = this.currentRow;
      this.changeDepartureTimeStrFormVisible = true;
      this.changeDepartureTimeStrForm = Object.assign({}, row);
    },
     // 单条任务包车
     handleChangeCharterSingleTask (){
      let row = this.currentRow;
      this.changeCharterFormVisible = true;
      this.changeCharterForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      let _this = this;
      let templatePara = {
        busLinesId: _this.filters.busLinesId,
        page: 1,
        pageSize: 200
      };
      getSchedulingTemplateListPage(templatePara).then(res => {
        this.schedulingtemplateList = res.data.response.data;
      });
      this.addForm.BusLinesId = _this.filters.busLinesId;
      this.addForm.BusLinesName = _this.filters.busLinesName;
      this.addForm.SchedulingTemplateId = null;
      this.addForm.DriverId = null;
      this.addForm.VehicleId= null;
      this.addForm.ShiftName= null;
      this.addForm.DepartureDate = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate();
      this.addFormVisible = true;
    },
    // 包车
    handleCharterTask(){
      this.$confirm("确认包车吗？", "提示", {}).then(() => {
        let rowData = Object.assign({}, this.currentRow);
        let para = {
          Id: rowData.Id,
          IsCharter: true
        };
        runCenterCharterTask(para).then(res => {
          if (util.isEmt.format(res)) {
            return;
          }

          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });

            this.taskDetailsFormVisible = false;
            this.queryRunCenterTask();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      }).catch(() => {
          
      });
    },
    // 取消包车
    handleCancelCharterTask(){
      this.$confirm("确认取消包车吗？", "提示", {}).then(() => {
        let rowData = Object.assign({}, this.currentRow);
        let para = {
          Id: rowData.Id,
          IsCharter: false
        };
        runCenterCancelCharterTask(para).then(res => {
          if (util.isEmt.format(res)) {
            return;
          }

          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });

            this.taskDetailsFormVisible = false;
            this.queryRunCenterTask();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      }).catch(() => {
          
      });
    },
    //导出任务数据
    handleExport() {
      let para = {
        
      };
      exportRunCenterTask(para).then(res => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        }); // 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
        let url = window.URL.createObjectURL(blob); // 3.创建一个临时的url指向blob对象
        // 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
        let a = document.createElement("a");
        a.href = url;
        a.download = "运行中心" + currentDate() + "日数据.xlsx";
        a.click();
        // 5.释放这个临时的对象url
        window.URL.revokeObjectURL(url);
      },
        (err) => {
          resolve(err.response);
        })
        .catch((error) => {
          reject(error);
        });
    },
    queryRunCenterTask(){
      this.page = 1;
      this.getRunCenterTask();
    },
    getStyle(from,state){
      let styleContent = "padding-left:5px;padding-right:5px;padding-top:3px;padding-bottom:5px;";

      if(from === 0){
        styleContent += "float:right;";
      } else if(from === 1) {
        styleContent += "color:#606266;margin-right:5px;";
      }

      if(state === 1){
        styleContent += "background-color:#FFF8DC;";
      } else if(state === 2) {
        styleContent += "background-color:#7FFFD4;";
      } else if(state===3||(state>5 && state<11)){
        styleContent += "background-color:#F08080;";
      } else if(state === 4) {
        styleContent += "background-color:#A9A9A9;";
      } else if(state === 5){
        styleContent += "background-color:#87CEFA;";
      } else if(state === 11){
        styleContent += "background-color:#ffa41b;";
      } 

      return styleContent;
    },
    getStylecolor(from,state){
      let styleContentcolor = "width:10px; height:10px;border-radius:50%;margin-top:5px;margin-right:5px;";

      if(from === 0){
        styleContentcolor += "float:left;";
      } else if(from === 1) {
        styleContentcolor += "color:#606266;margin-right:5px;";
      }

      if(state === 1){
        styleContentcolor += "background-color:#FFF8DC;";
      } else if(state === 2) {
        styleContentcolor += "background-color:#7FFFD4;";
      } else if(state === 3 ){
        styleContentcolor += "background-color:#F08080;";
      } else if(state === 4) {
        styleContentcolor += "background-color:#A9A9A9;";
      } else if(state === 5){
        styleContentcolor += "background-color:#87CEFA;";
      } else if(state === 11){
        styleContentcolor += "background-color:#ffa41b;";
      } 

      return styleContentcolor;
    },
    // 显示详细
    handleShowDetails(item,lineName,licensePlateNumber,driverName){
      this.runCenterTaskDetails = [];
      let taskObject = {
        Id:item.Id,
        VehicleId:item.VehicleId,
        DriverId:item.DriverId,
        IsCharter:item.IsCharter,
        LineName:lineName,
        ShiftName:item.ShiftName,
        Times:item.Times,
        LicensePlateNumber:licensePlateNumber,
        DriverName:driverName,
        SchedulingShiftRecordId:item.SchedulingShiftRecordId,
        DepartureTimeStr:item.DepartureTimeStr,
        ActualDepartureTimeStr:item.ActualDepartureTimeStr,
        ActualEndTimeStr:item.ActualEndTimeStr,
    //    TimeDifference:item.TimeDifference===0?"":item.TimeDifference,
        TimeDifference:item.TimeDifference,
        StateName:item.StateName,
        State:item.State,
        StartTimeStr:item.StartTimeStr,
        EndTimeStr:item.EndTimeStr,
        StartAddr:item.StartAddr,
        EndAddr:item.EndAddr,
        DisposeResults:item.DisposeResults,
        DisposeResultsName:item.DisposeResultsName,
        AbnormalCause:item.AbnormalCause
      };
      this.runCenterTaskDetails[0] = taskObject;
      this.taskDetailsFormVisible = true;
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      this.editForm.BeforeUpdateVehicleId = this.editForm.VehicleId;
      this.editForm.BeforeUpdateDriverId = this.editForm.DriverId;
    },
     //显示新增包车界面     	
     handleAddCharter() {
      let _this = this;      
      this.addCharterForm.BusLinesId = _this.filters.busLinesId;     
      this.addCharterForm.DriverId = null;
      this.addCharterForm.VehicleId= null;
 //     this.addCharterForm.DepartureDate = _this.filters.departureDate === ""?currentNextDate(1):_this.filters.departureDate;
      this.addCharterFormVisible = true;
    },
    //修改司机change
    AddDrivechange() {
      let _this = this;
      let para = {
        busLinesId: _this.addForm.BusLinesId,
        driverId: _this.addForm.DriverId,
        vehicleId: '',
        isBind: '',
        page: _this.page,
        pageSize: _this.pageSize
      }; 
      getByDriverIdVehiclesData(para).then(res => {
        if(res.data.data !== null)
        {
          if(res.data.data.length > 0)
          {
            _this.addForm.VehicleId = res.data.data[0].Id;
          }
        }  
      });  
    },
     //修改司机change
     AddCharterDrivechange() {
      let _this = this;
      let para = {
        busLinesId: _this.addCharterForm.BusLinesId,
        driverId: _this.addCharterForm.DriverId,
        vehicleId: '',
        isBind: '',
        page: _this.page,
        pageSize: _this.pageSize
      };    
      getByDriverIdVehiclesData(para).then(res => {
        if(res.data.data !== null)
        {
          if(res.data.data.length > 0)
          {
            _this.addCharterForm.VehicleId = res.data.data[0].Id;
          }
        }  
      });      
    },
    //查看操作日记
    lookUpOperateDataLog() {
      this.TwoTableOperateDataLogFormVisible = true; 
      this.oneEntityName= 'RunCenterTask';
      this.twoEntityName="Scheduling";
      this.oneEntityKey = this.currentRow.Id;
      this.twoEntityKey=this.currentRow.SchedulingId;
    },
    //任务详细查看操作日记
    taskDetailLookUpOperateDataLog() {
      this.TwoTableOperateDataLogFormVisible = true; 
      this.oneEntityName= 'RunCenterTask';
      this.twoEntityName="SchedulingShiftRecord";
      this.oneEntityKey = this.currentRow.Id;
      this.twoEntityKey=this.currentRow.SchedulingShiftRecordId;
    },
    //获取运行中心任务列表
    getRunCenterTask() {
      let _this = this;
      let para = {
        busLinesId: _this.filters.busLinesId,
        shiftName: _this.filters.shiftName,
        driverId: _this.filters.driverId,
        vehicleId: _this.filters.vehicleId,
        taskState: _this.filters.taskState,
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getRunCenterTaskListPage(para).then(res => {
        _this.total = res.data.dataCount;
        _this.runCenterTaskList = res.data.data;
        _this.listLoading = false;
      });
    },
    getBusLines(pageSizePara){
      getBusLinesListPage(pageSizePara).then(res => {
        this.busLiness = res.data.response.data;
        this.filters.busLinesId = res.data.response.data.length > 0?res.data.response.data[0].Id:"";
        this.getRunCenterTask();
      });
    },
    getDriverList(){
      let driverPara = {
        companyId: "",
        driverName: "",
        employmentStatus: "",
        page: 1,
        pageSize: 200
      };
      getDriverListPage(driverPara).then(res => {
        this.driverList = res.data.response.data;
      });
    },
    getVehiclesList(){
      let vehiclesPara = {
        companyId: '',
        busLinesId: '',
        licensePlateNumber: '',
        terminalsId: '',
        simId: '',
        page: 1,
        pageSize: 200
      };
      getVehiclesListPage(vehiclesPara).then(res => {
        this.vehicleList = res.data.response.data;
      });
    },
    getShiftNameList(schedulingTemplateId){
      this.shiftNameList = undefined;
      this.addForm.ShiftName= undefined;
      let para = {
        schedulingTemplateId:schedulingTemplateId
      };
      getShiftNameListPage(para).then(res => {
        this.shiftNameList = res.data;
      });
    }, 
    // 添加排班任务
    handleAddSchedulingTask(item,scheduling){
      let row = this.currentRow;
      this.addschedulingTaskForm.SchedulingId = row.SchedulingId;
      this.addschedulingTaskForm.BusLinesId = row.BusLinesId;
      this.addschedulingTaskForm.LineName = row.LineName;
      this.addschedulingTaskForm.ShiftName = row.ShiftName;
      this.addschedulingTaskForm.VehicleId = row.VehicleId;
      this.addschedulingTaskForm.OldVehicleId = row.OldVehicleId;
      this.addschedulingTaskForm.DriverId = row.DriverId;
      this.addschedulingTaskForm.OldDriverId = row.OldDriverId;
      this.addschedulingTaskForm.DepartureDate = row.DepartureDate;
      if(row.LineMode == "环行")
      {
        this.addschedulingTaskForm.LineMode = "环行";
        this.addschedulingTaskForm.Isdisabled = true;
      }else
      {
        this.addschedulingTaskForm.LineMode = "上行";
        this.addschedulingTaskForm.Isdisabled = false;
      }
      // if(item.SchedulingShiftRecord.Id > 0){
      //   this.addschedulingTaskForm.DepartureTimeStr = item.SchedulingShiftRecord.DepartureTimeStr;
      //   this.addschedulingTaskForm.VehicleId = item.SchedulingShiftRecord.VehicleId === null?scheduling.VehicleId:item.SchedulingShiftRecord.VehicleId;
      //   this.addschedulingTaskForm.OldVehicleId = item.SchedulingShiftRecord.VehicleId === null?scheduling.VehicleId:item.SchedulingShiftRecord.VehicleId;
      //   this.addschedulingTaskForm.DriverId = item.SchedulingShiftRecord.DriverId;
      //   this.addschedulingTaskForm.OldDriverId = item.SchedulingShiftRecord.DriverId;
      // } else {
      //   this.addschedulingTaskForm.DepartureTimeStr = item.DepartureTimeStr;
      //   this.addschedulingTaskForm.VehicleId = scheduling.VehicleId;
      //   this.addschedulingTaskForm.OldVehicleId = scheduling.OldVehicleId;
      //   this.addschedulingTaskForm.DriverId = scheduling.DriverId;
      //   this.addschedulingTaskForm.OldDriverId = scheduling.OldDriverId;
      // }
      this.handleAddSchedulingTaskFormVisible = true;
      
    },
    //显示异常处理界面
    handleAbnormalDispose() {
      this.AbnormalFormVisible = true;
      let row = this.currentRow;
      this.AbnormalForm = Object.assign({}, row);
    },
    //异常处理
    AbnormalSubmit: function () {
        this.$refs.AbnormalForm.validate(valid => {
           if (valid) {
            this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.AbnormalLoading = true;
            let para = Object.assign({}, this.AbnormalForm);
            RunCenterTaskAbnormalDisposeUser(para).then(res => {
              if (util.isEmt.format(res)) {
                this.AbnormalLoading = false;
                return;
              }

              if (res.data.success) {
                this.AbnormalLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.AbnormalFormVisible = false;
                this.taskDetailsFormVisible=false;
                this.$refs["AbnormalForm"].resetFields();
                this.getRunCenterTask();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
            }
        });
    },
    // 添加排班任务
    addSchedulingTaskSubmit: function() {
      this.$refs.addschedulingTaskForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addSchedulingTaskLoading = true;
            let para = Object.assign({}, this.addschedulingTaskForm);
            postRunCenterTask(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addSchedulingTaskLoading = false;
                return;
              }

              if (res.data.success) {
                this.addSchedulingTaskLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addschedulingTaskForm"].resetFields();
                this.handleAddSchedulingTaskFormVisible = false;
                this.getRunCenterTask();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          }).catch(() => {
          
          });
        }
      });
    },
     //新增包车
     addCharterTaskSubmit: function() {   
      let _this = this;
      
      this.$refs.addCharterForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addCharterLoading = true;
            let para = Object.assign({}, this.addCharterForm);          
            runCenteraddCharterTask(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addCharterLoading = false;
                return;
              }
              if (res.data.success) {
                this.addCharterLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addCharterForm"].resetFields();
                this.addCharterFormVisible = false;
                this.getRunCenterTask();
              } else {
                this.addCharterLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          })
          .catch(() => {
          
          });
        }
      });
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let para = Object.assign({}, this.editForm);

            editRunCenterTask(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.queryRunCenterTask();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //编辑换车
    changeVehicleSubmit: function() {
      this.$refs.changeVehicleForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.changeVehicleLoading = true;
            let para = Object.assign({}, this.changeVehicleForm);
            para.TimeDifference = 0;
            runCenterChangeVehicleSingleTask(para).then(res => {
              if (util.isEmt.format(res)) {
                this.changeVehicleLoading = false;
                return;
              }

              if (res.data.success) {
                this.changeVehicleLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["changeVehicleForm"].resetFields();

                this.changeVehicleFormVisible = false;
                this.taskDetailsFormVisible = false;
                this.queryRunCenterTask();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //编辑换司机
    changeDriverSubmit: function() {
      this.$refs.changeDriverForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.changeDriverLoading = true;
            let para = Object.assign({}, this.changeDriverForm);
            para.TimeDifference = 0;
            runCenterChangeDriverSingleTask(para).then(res => {
              if (util.isEmt.format(res)) {
                this.changeDriverLoading = false;
                return;
              }

              if (res.data.success) {
                this.changeDriverLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["changeDriverForm"].resetFields();

                this.changeDriverFormVisible = false;
                this.taskDetailsFormVisible = false;
                this.queryRunCenterTask();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //编辑换发车时间
    changeDepartureTimeStrSubmit: function() {
      this.$refs.changeDepartureTimeStrForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.changeDepartureTimeStrLoading = true;
            let para = Object.assign({}, this.changeDepartureTimeStrForm);
            para.TimeDifference = 0;
            runCenterChangeDepartureTimeStrSingleTask(para).then(res => {
              if (util.isEmt.format(res)) {
                this.changeDepartureTimeStrLoading = false;
                return;
              }

              if (res.data.success) {
                this.changeDepartureTimeStrLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["changeDepartureTimeStrForm"].resetFields();

                this.changeDepartureTimeStrFormVisible = false;
                this.taskDetailsFormVisible = false;
                this.queryRunCenterTask();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
      //编辑包车
      changeCharterSubmit: function() {
      this.$refs.changeCharterForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.changeCharterLoading = true;
            let para = Object.assign({}, this.changeCharterForm);
            para.TimeDifference = 0;
            runCenterChangeCharterSingleTask(para).then(res => {
              if (util.isEmt.format(res)) {
                this.changeCharterLoading = false;
                return;
              }

              if (res.data.success) {
                this.changeCharterLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["changeCharterForm"].resetFields();

                this.changeCharterFormVisible = false;
                this.taskDetailsFormVisible = false;
                this.queryRunCenterTask();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function() {
      let _this = this;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addRunCenterTask(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getRunCenterTask();
              } else {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          })
          .catch(() => {
          
          });
        }
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    }
  },
  mounted() {
    let pageSizePara = {
      pageSize: 100
    };
    this.getBusLines(pageSizePara);
    this.getDriverList();
    this.getVehiclesList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    let para = {
      dictName: '处理结果',
      dictCode: 'DisposeResults',
      pageSize: 100
    };
    getDictionaryListPageByDictNameAndDictCode(para).then(res => {
      this.disposeResultsModeList = res.data.data;
    });
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);
    
    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped>
  
</style>
